import {
  Component,
  QueryList,
  ViewChildren,
} from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from "@angular/material/datepicker";
import { MatFormField, MatInput, MatLabel, MatSuffix } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatOption } from "@angular/material/autocomplete";
import { MatSelect } from "@angular/material/select";
import { MatTooltip } from "@angular/material/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { take, takeUntil } from "rxjs";
import { Area } from "src/app/shared/model/tickets/area.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { NotificacionTicketComponent } from "../../atencion/notificacion-ticket/notificacion-ticket.component";
import {
  TableroTicketsBaseComponent,
  VistaTableroTickets,
} from "../../tickets-comun/tablero-tickets-base.component";
import { SelectionTicketsComponent } from "../selection-tickets/selection-tickets.component";
import { NotificacionCteTicketComponent } from "../notificacion-cte-ticket/notificacion-cte-ticket.component";

/** Tablero del cliente; su plantilla también la pinta el tablero de atención (GestionTicketsComponent). */
@Component({
  selector: "app-gestion-cte-tickets",
  standalone: true,
  templateUrl: "./gestion-cte-tickets.component.html",
  styleUrls: ["./gestion-cte-tickets.component.css"],
  imports: [
    AsyncPipe,
    FormsModule,
    MatButtonModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    MatTooltip,
    NgFor,
    NgIf,
    NgxMatSelectSearchModule,
    NotificacionCteTicketComponent,
    NotificacionTicketComponent,
    ReactiveFormsModule,
  ],
})
export class GestionCteTicketsComponent extends TableroTicketsBaseComponent {
  readonly vista: VistaTableroTickets = {
    clasePagina: "tickets-client-page",
    iconoAccion: "add",
    textoAccion: "Solicitar",
    accionSecundaria: false,
    columnasCliente: true,
    textoSinAreas: "No fue posible cargar las áreas para el tablero de tickets del cliente.",
  };

  @ViewChildren(NotificacionCteTicketComponent)
  ticketBoards!: QueryList<NotificacionCteTicketComponent>;

  protected get prefijoPaginacion(): string {
    return "ticket-client-board";
  }

  accionPrincipal(): void {
    this.solicitudTickets();
  }

  protected override suscribirAvisosDeCambio(): void {
    super.suscribirAvisosDeCambio();

    this.ticketsService.actualizacionDetalleEmitter
      .pipe(takeUntil(this.destroy$))
      .subscribe((ticketActualizado) => {
        if (ticketActualizado) {
          this.marcarColumnasPendientes(ticketActualizado);
        }
      });

    this.ticketsService.nuevoTicketEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.deferRefreshAll();
    });
  }

  solicitudTickets(): void {
    const dialogRef = this.dialog.open(SelectionTicketsComponent, {
      disableClose: true,
      autoFocus: true,
      width: "40%",
      panelClass: "custom-modalbox",
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      if (this.dialog.openDialogs.length > 0) {
        this.dialog.afterAllClosed.pipe(take(1)).subscribe(() => {
          this.deferRefreshAll();
        });
        return;
      }

      this.deferRefreshAll();
    });
  }

  protected asignarAreas(areasCatalogo: Area[], areasUsuario: Area[]): void {
    const defaultAreaId = Number(areasUsuario[Constantes.CERO]?.id ?? 0);
    const selectedArea =
      areasCatalogo.find((area) => area.id === defaultAreaId) ?? areasCatalogo[0] ?? null;

    this.areas = areasCatalogo;
    this.areaSeleccionada = selectedArea ? { ...selectedArea } : null;
    this.filterArea.next(this.areas.slice());
    this.options.patchValue({ areaCtrl: this.areaSeleccionada }, { emitEvent: false });

    if (this.areaSeleccionada) {
      this.deferRefreshAll();
    }
  }
}
